import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import type { ResponsiveProductCardSettings } from 'product-card/context/ProductCardConsumerLayoutContext/ProductCardConsumerLayoutContext'
import type { View } from 'product-list/types/View'
import { getDefaultProductCardSettings } from 'product-list/utils/getDefaultProductCardSettings/getDefaultProductCardSettings'
import { useMemo } from 'react'

export const useDefaultProductCardSettings: () => Record<
	View,
	ResponsiveProductCardSettings
> = () => {
	const {
		country: { hasOnlineSale },
	} = useMasterData()
	return useMemo(
		() => getDefaultProductCardSettings({ hasOnlineSale }),
		[hasOnlineSale]
	)
}
